import { useDisableRefetchOnFocus } from 'lib/reactQuery/useDisableRefetchOnFocus';

import {
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
  Typography,
} from 'shared';
import Box from 'shared_DEPRECATED/components/Box/Box';
import { Flex } from 'shared_DEPRECATED/components/Flex';
import FileUpload from 'shared_DEPRECATED/components/Form/FileUpload/FileUpload';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';
import useToggle from 'shared_DEPRECATED/hooks/useToggle';

import { useChatAttachmentsContext } from 'features/chat/context/chatAttachments';

import { Button, ButtonIcon } from 'shared/components/Button';

type ChatAttachmentProps = {
  disabled: boolean;
};

export default function ChatAttachment(props: ChatAttachmentProps) {
  const { handleFileChange, handleMediaChange } = useChatAttachmentsContext();
  const [open, toggleOpen] = useToggle();

  useDisableRefetchOnFocus();

  return (
    <PopoverRoot open={open} onOpenChange={toggleOpen}>
      <PopoverTrigger asChild>
        <Box>
          <ButtonIcon
            aria-label="attachment"
            bg="var(--bgPrimary)"
            disabled={props.disabled}
            data-testid="add-attachment-btn"
            size="md"
          >
            <Icon
              name={iconNames.clip}
              height="18px"
              width="18px"
              fill={open ? 'var(--fgInteractive)' : 'var(--fgSecondary)'}
            />
          </ButtonIcon>
        </Box>
      </PopoverTrigger>
      <PopoverContent>
        <Button
          variant="ghost"
          size="sm"
          borderRadius="0"
          padding="0"
          justifyContent="flex-start"
        >
          <FileUpload
            onFileUpload={(files) => {
              toggleOpen();
              handleFileChange(files);
            }}
            dataTestid="attachment-file-btn"
          >
            <Spacer size="md">
              <Flex alignItems="center" gap="var(--spacing01)">
                <Icon
                  name={iconNames.document}
                  stroke="var(--fgTertiary)"
                  strokeWidth={1}
                />
                <Typography color="black" fontWeight="medium" type="small">
                  File
                </Typography>
              </Flex>
            </Spacer>
          </FileUpload>
        </Button>
        <Button
          variant="ghost"
          size="sm"
          borderRadius="0"
          padding="0"
          justifyContent="flex-start"
        >
          <FileUpload
            onFileUpload={(files) => {
              toggleOpen();
              handleMediaChange(files);
            }}
            extensions="image/*,video/*,application/vnd.apple.mpegurl"
            dataTestid="attachment-image-or-video-btn"
          >
            <Spacer size="md">
              <Flex alignItems="center" gap="var(--spacing01)">
                <Icon
                  name={iconNames.image}
                  stroke="var(--fgTertiary)"
                  strokeWidth={1}
                />
                <Typography color="black" fontWeight="medium" type="small">
                  Image or Video
                </Typography>
              </Flex>
            </Spacer>
          </FileUpload>
        </Button>
      </PopoverContent>
    </PopoverRoot>
  );
}
